import type { ThemeDefinition } from '../index';

/** m 基础主题（ecom 模式：主站/站点独立站/HQB；dl 阶段 3 拆出前暂共用） */
const mTheme: ThemeDefinition = {
  code: 'm',
  mode: 'ecom',
};

export default mTheme;
